import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Banner.module.scss';
import bs from '../../styles/bootstrap-overrides.scss';
import tick from '../../assets/tick.svg';
import error from '../../assets/error.svg';
import warningIcon from '../../assets/warning.svg';
import Alert from 'react-bootstrap/Alert';

const Banner = ({ failureText, status, showBanner, successText, warning }) => {
  const statusText = status ? successText : failureText;
  const iconSrc = status ? (warning ? warningIcon : tick) : error;
  const [show, setShow] = useState(true);
  const [visible, setVisible] = useState(false);

  // Handle visibility with useEffect instead of using Transition component
  useEffect(() => {
    let timeoutId = null;
    
    if (showBanner) {
      // Show immediately
      setVisible(true);
      
      // Auto-hide after 2500ms (matching the original timeout)
      timeoutId = setTimeout(() => {
        if (!showBanner) {
          setVisible(false);
        }
      }, 2500);
    } else {
      // Hide
      setVisible(false);
    }
    
    // Clean up timeout
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [showBanner]);

  if (!statusText || statusText === '') {
    return <div></div>;
  }

  // Only render if visible
  if (!visible || !show) {
    return null;
  }

  return (
    <div className={classNames(s.banner, { [s.enter]: visible })}>
      <Alert variant={!status ? 'danger' : warning ? 'warning' : 'success'} onClose={() => setShow(false)} dismissible>
        <img src={iconSrc} alt="icon" />
        {statusText}
      </Alert>
    </div>
  );
};

Banner.propTypes = {
  status: PropTypes.bool,
  failureText: PropTypes.string,
  showBanner: PropTypes.bool.isRequired,
  successText: PropTypes.string,
  warning: PropTypes.bool
};

export default Banner;